export const Weights = [16, 20, 25, 40, 420, 450, 1500];
